import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingCheckList extends BaseModelAPI {

	static entity = 'newobject1928list'
	static entityName = 'outgoingcheck';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
